import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface UpSellingModalHeaderProps {
  children: ReactNode;
}

export default function UpSellingModalHeader({ children }: UpSellingModalHeaderProps) {
  return (
    <Flex
      alignItems="center"
      backgroundColor="pureBlue50"
      borderRadius="3px"
      justifyContent="center"
      mb={7}
      py={5}
      width="100%"
    >
      <Text color="textEmphasisBase" fontSize="md" fontWeight="regular" mr={3}>
        <FontAwesomeIcon icon={faExclamationCircle} />
      </Text>
      <Text color="textEmphasisBase" fontSize="md" fontWeight="regular">
        {children}
      </Text>
    </Flex>
  );
}
